import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { HttpSsrInterceptor } from './interceptors/ssr.interceptor';
import { HttpTokenInterceptor } from './interceptors/token.interceptor';
import { HttpErrorInterceptor } from './interceptors/http-error.interceptor';

export const CORE_HTTP_INTERCEPTOR_PROVIDERS = [{ provide: HTTP_INTERCEPTORS, useClass: HttpTokenInterceptor, multi: true }];
export const SSR_HTTP_INTERCEPTOR_PROVIDER = [{ provide: HTTP_INTERCEPTORS, useClass: HttpSsrInterceptor, multi: true }];
export const ERROR_HTTP_INTERCEPTOR_PROVIDER = [{ provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true }];
